module.exports = __webpack_public_path__ + "img/foot-right-back.67066154.png";